<template>
  <v-container>
    <h3>Employments</h3>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="tables"
      :items-per-page="5"
      class="elevation-1"
      show-expand
      item-key="employment_Join_Date"
    >
      <template v-slot:item.employment_Join_Date="{ item }">
        {{ formatDate(item.employment_Join_Date) }}
      </template>
      <template v-slot:item.first_Working_Day="{ item }">
        {{ formatDate(item.first_Working_Day) }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <assignments :tables="item.assignments" />
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: ["tables"],
  components: {
    assignments: () => import("./employeeAssignment.vue")
  },
  data: () => ({
    headers: [
      {
        text: "Join Date",
        value: "employment_Join_Date"
      },
      {
        text: "First Working Day",
        value: "first_Working_Day"
      },
      {
        text: "Contracted Hours",
        value: "contracted_Hours"
      },
      {
        text: "Employment Authorization",
        value: "employment_Authorization"
      },
      {
        text: "Onboarding Status",
        value: "onboarding_Status"
      },
      { text: "", value: "data-table-expand" }
    ],
    isLoading: false
  }),
  created() {},
  methods: {
    formatDate: date => moment(date).format("YYYY-MM-DD hh:mm A")
  }
};
</script>
